<template>
<v-sheet v-if="Object.keys(urlFilters).length > 0" border rounded class="pa-3 selectorfilters" style="background-color: white;">
    <v-row>
    <v-col
        class="flex-grow-1 flex-shrink-0"
        cols="1"
        style="min-width: 100px; max-width: 100%;"
      >
            <div class="d-flex flex-wrap" style="gap: 8px;">
                    <span class="text-body-2 font-weight-bold pr-3 pt-2">{{dataAll.getStatic('product_chosen_filter_title', "Your selected filters")}}</span>
                    <v-chip
                        v-for="(selectorItem, index) in urlFilters"
                        :key="index"
                        closable
                        @click:close="removeFilter(index)"
                        size="small"
                    >
                        <strong>{{ getFilterName(index) }}:</strong>&nbsp;{{ Array.isArray(selectorItem) ? selectorItem.join(', ') : selectorItem }}
                    </v-chip>
            </div>
      </v-col>

      <v-col
        class="flex-grow-0 flex-shrink-1"
        cols="auto"
   
      >
            <v-btn
                variant="text"
                size="small"
                class="text-decoration-none text-none"
                @click="clearAllFilters"
            >
                {{dataAll.getStatic('product_chosen_filter_remove_all', "Remove all filters")}}
            </v-btn>
      </v-col>
    </v-row>
   
</v-sheet>

</template>
<script setup>
const { $PAG } = useNuxtApp()
const dataAll = useDataAll();
const props = defineProps({
    pagData: {
        type: Object,
        default: "",
    }, 
    selectors: {
        type: Object,
        default: "",
    }, 
});
// create an array with de AttribuutSelectorName and the select Name
const AttribuutSelectorNameLabel = computed(() => {
    return props.selectors.reduce((acc, item) => {
        if (item.AttribuutSelectorName && item.SelectorName) {
            acc[item.AttribuutSelectorName] = item.SelectorName;
        }
        return acc;
    }, {});
})

function getFilterName(filterKey){
    const item = getLabelByFilterKey(filterKey)

    // get label 
    return AttribuutSelectorNameLabel.value[item?.label] || item?.label || '';
}

function getLabelByFilterKey(filterKey){
    // find the facet in pagData by filter key
    const item = props.pagData?.facets?.find(item => item?.config?.filterKey == filterKey);
    return item || {};
}

function removeFilter(key) {   
    // remove 1 specific filter
    const updatedFilters = { ...urlFilters };
    delete updatedFilters[key];
    // if a filter is set delete page_nr, so we go to the first page of the results
    delete updatedFilters['page_nr'];
    // update url
    $PAG.updateFilter(updatedFilters, null);
}

function clearAllFilters() {    
    // remove all filters
    const emptyFilters = {};

    // update url
    $PAG.updateFilter(emptyFilters, null);
}

// retrieve all filters form the url, page_size and sort etc. are excluded
const urlFilters =$PAG.selectFilterValueByUrlOnlyFilter(); 
</script>

